import { Directive, ElementRef, Input } from '@angular/core';
import { fairAny } from 'dku-frontend-core';

@Directive({ selector: '[indeterminate]' })
export class IndeterminateDirective {
    @Input()
    set indeterminate(value: fairAny) {
        this.elem.nativeElement.indeterminate = value;
    }
    constructor(private elem: ElementRef) {
    }
}
